import { App } from '@ps20-frontend/frontend-models';
import { IAppState } from '../localStore';

export const appSourcePathConfigSelectorGenerator = (app: App) => (appState: IAppState) =>
  appState.transientState.appSourcePathConfigs[app];

export const appVorbelegungPendingSelectorGenerator = (app: App) => (appState: IAppState) =>
  appState.transientState.appVorbelegungPending[app];

export const selectShowPhAngebot: (state: IAppState) => boolean = (state: IAppState) =>
  appSourcePathConfigSelectorGenerator(App.PH)(state) &&
  !appVorbelegungPendingSelectorGenerator(App.PH)(state);
